var $34a6eb7890264192$exports = {};
$34a6eb7890264192$exports = {
    "dismiss": `\u{53D6}\u{6D88}`
};


export {$34a6eb7890264192$exports as default};
//# sourceMappingURL=zh-CN.mjs.map
